module.exports = __webpack_public_path__ + "static/media/gallery-18.fe23711b.jpg";